import RestAPI from '../RestApi'

export function fetchCurrentProApi() {
  return RestAPI.get('/api/v2/community/member/current_pro')
}
